import React, { useState } from 'react';
import ConfirmationModal from '../../elements/ConfirmationModal';
import { Check } from '@mui/icons-material';
import { completeTestCycle } from '../../../modules/testcycles';
import CustomIconButton from '../../elements/CustomIconButton';

const MarkTestCycleComplete = ({ row, fetchTestCycles, addNotification }) => {
  const [showFirstConfirm, setShowFirstConfirm] = useState(false);
  const [showSecondConfirm, setShowSecondConfirm] = useState(false);
  
  const handleCompleteTestCycle = async () => {
    try {
      await completeTestCycle(row.id);
      fetchTestCycles();
      addNotification('success', 'Test cycle has been marked as completed!');
    } catch (error) {
      const errorMessage =
        error?.message ||
        'Failed to update close test cycle. Please try again.';
      addNotification('danger', errorMessage);
    }
  };

  const handleFirstConfirm = () => {
    setShowFirstConfirm(false);
    setShowSecondConfirm(true);
  };

  const handleSecondConfirm = () => {
    handleCompleteTestCycle();
    setShowSecondConfirm(false);
  };

  return (
    <>
      <CustomIconButton
        title={
          row?.completion_date === null
            ? 'Complete Test Cycle'
            : 'Test Cycle is completed'
        }
        disabled={row?.completion_date !== null}
        onClick={() => setShowFirstConfirm(true)}>
        <Check
          sx={{ color: row?.completion_date !== null ? 'grey' : 'green' }}
        />
      </CustomIconButton>

      <ConfirmationModal
        show={showFirstConfirm}
        buttonStyle="warning"
        handleConfirm={handleFirstConfirm}
        handleClose={() => setShowFirstConfirm(false)}
        title="Complete Test Cycle"
        body={
          <div>
            <p>
              Once the test cycle is marked as completed, the following actions
              will no longer be possible:
            </p>
            <ul>
              <li>Edit the test cycle details</li>
              <li>Execute test cases within the cycle</li>
            </ul>
            <p>Do you want to continue?</p>
          </div>
        }
      />

      <ConfirmationModal
        show={showSecondConfirm}
        buttonStyle="error"
        handleConfirm={handleSecondConfirm}
        handleClose={() => setShowSecondConfirm(false)}
        title="Complete Test Cycle"
        body={
          <div>
            <p style={{ color: 'red' }}>
              This action is irreversible and cannot be undone.
            </p>
            <p>
              Once the test cycle is marked as completed, you will not be able
              to make any further changes or modifications.
            </p>
            <p>Are you absolutely sure you want to complete this test cycle?</p>
          </div>
        }
      />
    </>
  );
};

export default MarkTestCycleComplete;
